import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import { URL } from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

// Types
export const BUSCAR_BAGAGENS = '@bagagemActions/BUSCAR_BAGAGENS';
export const BUSCAR_BAGAGEM_POR_ID = '@bagagemActions/BUSCAR_BAGAGEM_POR_ID';
export const CRIAR_BAGAGEM = '@bagagemActions/CRIAR_BAGAGEM';
export const ALTERAR_BAGAGEM = '@bagagemActions/ALTERAR_BAGAGEM';
export const EXCLUIR_BAGAGEM = '@bagagemActions/EXCLUIR_BAGAGEM';
export const SELECIONAR_BAGAGEM = '@bagagemActions/SELECIONAR_BAGAGEM'
export const DETERMINAR_PAGINA_ATUAL_BAGAGENS = '@bagagemActions/DETERMINAR_PAGINA_ATUAL_BAGAGENS';
export const ALTERAR_NUMERO_REGISTROS_POR_PAGINA_BAGAGENS = '@bagagemActions/ALTERAR_NUMERO_REGISTROS_POR_PAGINA_BAGAGENS';
export const ALTERAR_EXIBICAO_BAGAGEM = '@bagagemActions/ALTERAR_EXIBICAO_BAGAGEM';

// Actions
export function buscarBagagens(empresaId, pagina, registrosPorPagina, filtros) {
    const urlFiltros = montarURLFiltro(filtros, 1, registrosPorPagina);
    const url = `${URL}/bagagem/empresa/${empresaId}/totalizadores${urlFiltros}`;
      return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
          type: BUSCAR_BAGAGENS,
          payload: response.data
        })
      );
}

export function buscarBagagemPorId(idBagagem) {
  return dispatch => axios.get(`${URL}/bagagem/${idBagagem}`, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_BAGAGEM_POR_ID,
      payload: response.data
    })
  );
}

export function cadastrarBagagem(bagagem) {
  return dispatch => axios.post(`${URL}/bagagem/cadastrar`, bagagem, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CRIAR_BAGAGEM,
      payload: response.data
    })
  );
}

export function alterarBagagem(bagagem) {
  return dispatch => axios.post(`${URL}/bagagem/atualizar`, bagagem, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ALTERAR_BAGAGEM,
      payload: response.data
    })
  );
}

export function excluirBagagem(idBagagem) {
  return dispatch =>
    axios.delete(`${URL}/bagagem/${idBagagem}/excluir`, SLOW_REQUEST_CONFIG).then(
      () =>
        dispatch({
          type: EXCLUIR_BAGAGEM,
          payload: idBagagem,
        })
    );
}



export function determinarPaginaAtualBagagens(paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_BAGAGENS,
    payload: paginaAtual
  };
}

export function alterarExibicaoBagagem(bagagem) {
  return {
    type: ALTERAR_EXIBICAO_BAGAGEM,
    payload: bagagem
  };
}

export function alterarRegistrosPorPaginaBagagens(valor) {
  return {
    type: ALTERAR_NUMERO_REGISTROS_POR_PAGINA_BAGAGENS,
    payload: valor
  };
}

export function selecionaBagagem(bagagem) {
    return {
        type: SELECIONAR_BAGAGEM,
        payload: bagagem
    };
}
